import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3c5ad2bc")

_pushScopeId("data-v-3c5ad2bc")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Account")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Reset Password/Login")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Manage Subscription")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Add-ons")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Health App")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Connected")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Connect")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Update Profile")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Platform")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("About Us")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Support / Contact")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_navbar = _resolveComponent("navbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_alert = _resolveComponent("ion-alert")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_bottombar = _resolveComponent("bottombar")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { class: "ion-no-border" }, {
        default: _withId(() => [
          _createVNode(_component_navbar)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_ion_grid, null, {
              default: _withId(() => [
                _createVNode(_component_ion_row, null, {
                  default: _withId(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_item_divider, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          color: "light",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openResetModal()))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_icon, {
                              size: "small",
                              icon: _ctx.lockClosedOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          color: "light",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openSubscriptionModal()))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_icon, {
                              size: "small",
                              icon: _ctx.accessibilityOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          color: "light",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.logout()))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_icon, {
                              size: "small",
                              icon: _ctx.logOutOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (_ctx.isAndroid || _ctx.isIOS)
                          ? (_openBlock(), _createBlock("div", _hoisted_6, [
                              _createVNode(_component_ion_item_divider, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                color: "light",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.connectHealthApp()))
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_icon, {
                                    size: "small",
                                    icon: _ctx.heartOutline,
                                    slot: "start"
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.healthConnected)
                                    ? (_openBlock(), _createBlock(_component_ion_label, {
                                        key: 0,
                                        class: "text-sm",
                                        color: "success",
                                        slot: "end"
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_9
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (!_ctx.healthConnected)
                                    ? (_openBlock(), _createBlock(_component_ion_label, {
                                        key: 1,
                                        class: "text-sm",
                                        color: "primary",
                                        slot: "end"
                                      }, {
                                        default: _withId(() => [
                                          _hoisted_10
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_item, {
                                color: "light",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateUserProfile())),
                                disabled: !_ctx.healthConnected
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_icon, {
                                    size: "small",
                                    icon: _ctx.sync,
                                    slot: "start"
                                  }, null, 8, ["icon"]),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withId(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_item_divider, null, {
                          default: _withId(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          color: "light",
                          onClick: _cache[6] || (_cache[6] = () => _ctx.router.push('/about'))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_icon, {
                              size: "small",
                              icon: _ctx.openOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_13
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          color: "light",
                          onClick: _cache[7] || (_cache[7] = () => _ctx.router.push('/contact'))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_icon, {
                              size: "small",
                              icon: _ctx.helpBuoyOutline,
                              slot: "start"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, null, {
                              default: _withId(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_alert, {
              "is-open": _ctx.isOpenRef,
              header: "Health Data Permissions Denied!",
              "sub-header": "Cannot request access again",
              message: "Please enable access to health data in your privacy settings.",
              "css-class": "permissions-alert-dialog",
              buttons: _ctx.buttons,
              onDidDismiss: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setOpen(false)))
            }, null, 8, ["is-open", "buttons"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_bottombar)
    ]),
    _: 1
  }))
})